var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 289,
    viewBox: "0 0 278 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 175.488,
    height: 181.018,
    rx: 37,
    transform: "matrix(0.773595 0.633681 -0.773595 0.633681 140.051 62.1776)",
    fill: "#4A98FF",
    fillOpacity: 0.66
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 175.488,
    height: 181.018,
    rx: 37,
    transform: "matrix(0.773595 0.633681 -0.773595 0.633681 142.189 36.7393)",
    fill: "#4A98FF",
    fillOpacity: 0.66
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 175.488,
    height: 181.018,
    rx: 37,
    transform: "matrix(0.773595 0.633681 -0.773595 0.633681 142.189 0.538574)",
    fill: "#4A98FF",
    fillOpacity: 0.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.4098b6632fa8c7d481abbacb3da2d734.svg";
export { ForwardRef as ReactComponent };